import React from 'react'
import { Image, ImageProps } from '..'

const logoBlack =
    'https://assets.asktia.com/images/pastel_rebrand/logo-black.svg'
const logoWhite =
    'https://assets.asktia.com/images/pastel_rebrand/logo-white.svg'

interface LogoProps {
    /**
     * specify variant of logo to show
     */
    variant?: 'black' | 'white'
}

/**
 * The Logo component is used to show Tia's logo. It comes in 2 variants
 * - black
 * - white
 * Takes care of its own sizing, you have to position yourself.
 */
export const Logo = ({ variant = 'white', sx }: LogoProps & ImageProps) => {
    return (
        <Image
            src={variant === 'black' ? logoBlack : logoWhite}
            sx={{ height: 5, ...sx }}
        />
    )
}
